const palette = {
  white: 'rgb(255, 255, 255)',
  red_toyota: 'rgb(177, 56, 52)',
  gray: {
    primary: 'rgb(226, 224, 224)',
    dark: 'rgb(204, 204, 204)',
    light: 'rgb(147, 147, 162)',
    darker: 'rgba(215, 215, 215, 1.0)',
  },
  clear_blue: 'rgb(97, 218, 251)',
};

export default palette;
